module.exports = __webpack_public_path__ + "static/media/vLogo.a24f1813.png";